<template>
  <v-app style="background-color: #0b131c">
    <v-snackbar v-model="snackbar" :timeout="4000" :color="snackbarColor" top>
      {{ snackbarMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false" class="pa-0 ma-0">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="chorusStatusModal" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          全てを再実行
        </v-card-title>
        <v-card-text>
          {{ chorusStatusMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="chorusStatusModal = false">
            キャンセル
          </v-btn>
          <v-btn color="success" text @click="forceReRunChorusTask({ improve: 'all' })">
            再実行
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="improveTranscriptModal" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          {{ audioTextTab !== 0 && '話者分離のみを再実行' }}
        </v-card-title>
        <v-card-text>
          {{ audioTextTab !== 0 && '現在の話者分離情報は上書き保存されますが、文字起こしの内容には変更は加えられません。' }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="improveTranscriptModal = false" :disabled="improveLoading">
            キャンセル
          </v-btn>
          <v-btn color="success" text @click="confirmImproveTranscript" :loading="improveLoading">
            実行する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container
      v-if="fullLoading"
      fluid
      style="
        height: calc(100vh - 20px);
        margin: 10px;
        width: calc(100% - 20px);
        padding: 0;
        background-color: white;
        overflow: hidden;
        border-radius: 10px;
      "
    >
      <NewCallSkeleton />
    </v-container>

    <v-container
      v-else-if="!callDetails"
      fluid
      class="background-main main-container"
    
    >
      <div>
        <PageNotFound :errorMessage="'該当するコールが見つかりません'" />
      </div>
    </v-container>

    <v-container
      v-else
      fluid
      class="background-main main-container call-details-main-container"
      style="
        height: calc(100vh - 20px);
        margin: 10px;
        width: calc(100% - 20px);
        padding: 0px 20px 20px 20px;
      "
    >
      <div
        class="d-flex flex-wrap justify-center justify-sm-space-between	 align-center"
      >
        <div class="details-header  justify-sm-center w-sm-full">
            <div class="d-flex align-center">
            <img :src="documentationsIcon" alt="documentations" />
            <span
              class="ms-1 blackDark--text font-weight-medium cursor-pointer"
              @click="copyToClipboard(callDetails?.session_id)"
            >
              セッションID: {{ callDetails?.session_id }}
            </span>
          </div>
        </div>
        <div class="d-flex justify-center align-center">
          <div v-if="isAdmin" class="delete-call-details" @click="deleteCallSession(true)">
            <img :src="deleteIcon" alt="delete" class="cursor-pointer" />
            <span class="delete-btn">削除</span>
           <div class="bar ml-3 mr-1"></div>
          </div>
          <div v-if="userProfile?.first_name || userProfile?.middle_name || userProfile?.last_name" class="d-flex align-center cursor-pointer">
            <v-avatar size="36" class="">
              <v-icon>mdi-account-circle</v-icon>
            </v-avatar>
            <div class="text-no-wrap text-truncate" style="max-width: 200px;">
              {{ userProfile?.first_name }} {{ userProfile?.middle_name }} {{ userProfile?.last_name }}
            </div>
            <div class="bar mx-3"></div>
          </div>
          <template>
            <v-btn icon class="close-btn" @click="closeWindow(); interactionUpdate(INTERACTION_POINT.CALL_DETAIL_CALL_CLOSE, `閉じるアイコン`, callDetails?.session_id)" aria-label="Close window">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </div>
      </div>

      <!-- information section for digital projects -->
      <div class="information-div" v-if="!isAnalogProject">
        <!-- customer information -->
        <div class="information-card">
          <div class="d-flex justify-space-between align-center">
            <span class="card-title"> 相談者情報 </span>
            <img
              :src="editIcon"
              class="cursor-pointer"
              alt="edit"
              @click="editCallDetails('customer_info')"
            />
          </div>
          <div class="information-column first-info-col">
            <div class="border px-2 py-1">
              <p class="info-title">発信者番号：</p>
              <p class="info-value">
                {{ handlePhoneNumberFormat(callDetails?.src_id) }}
              </p>
            </div>
            <div class="border px-2 py-1">
              <p class="info-title">着信先：</p>
              <p class="info-value">
                {{ handlePhoneNumberFormat(callDetails?.dest_id) }}
              </p>
            </div>
            <!-- <div class="border px-2 py-1">
              <p class="info-title">メモ:</p>
              <p class="info-value">
                <template v-if="callDetails?.src_info">
                  {{
                    callDetails.src_info.length > 30
                      ? callDetails.src_info.substring(0, 30) + "..."
                      : callDetails.src_info
                  }}
                  <span
                    v-if="
                      callDetails &&
                      callDetails.src_info &&
                      callDetails.src_info.length > 30
                    "
                    @click="showFullTextFunc(callDetails?.src_info)"
                    class="primary--text font-weight-medium text-decoration-underline cursor-pointer"
                  >
                    View more
                  </span>
                </template>
                <template v-else> N/A </template>
              </p>
            </div> -->
          </div>
        </div>

        <!-- operator information -->
        <div class="information-card">
          <div class="d-flex justify-space-between align-center">
            <span class="card-title"> オペレーター情報 </span>
            <img
              :src="editIcon"
              class="cursor-pointer"
              alt="edit"
              @click="editCallDetails('operator_info')"
            />
          </div>
          <div class="information-column first-info-col">
            <div class="border px-2 py-1">
              <p class="info-title">相談員氏名：</p>
              <p class="info-value d-flex">
                {{
                  this.callDetails?.counselor_name
                    ? this.callDetails?.counselor_name
                    : "N/A"
                }}
              </p>
            </div>
            <div class="border px-2 py-1">
              <p class="info-title">電話機名:</p>
              <p class="info-value">
                <span v-if="callDetails?.dest_phone_name">
                  {{ callDetails?.dest_phone_name }} -
                  {{ callDetails?.dest_model_name }}
                </span>
                <span v-else>N/A</span>
              </p>
            </div>
            <!-- <div class="border px-2 py-1">
              <p class="info-title">メモ:</p>
              <p class="info-value">
                <template v-if="callDetails?.dest_info">
                  {{
                    callDetails.dest_info.length > 30
                      ? callDetails.dest_info.substring(0, 30) + "..."
                      : callDetails.dest_info
                  }}
                  <span
                    v-if="callDetails.dest_info.length > 30"
                    @click="showFullTextFunc(callDetails?.dest_info)"
                    class="primary--text font-weight-medium text-decoration-underline cursor-pointer"
                  >
                    View more
                  </span>
                </template>
                <template v-else> N/A </template>
              </p>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Call status section for digital projects -->
      <div class="information-card" v-if="!isAnalogProject">
        <div class="call-status-card" :class="{ 'call-status-card--analog': isAnalogProject }">
          <div class="border px-2 py-1">
            <p class="info-title">通話ステータス：</p>
            <p class="info-value text-capitalize">
              {{
                callDetails?.call_status === "on_going"
                  ? "録音中"
                  : callDetails?.call_status
              }}
            </p>
          </div>
          <div class="border px-2 py-1">
            <p class="info-title">通話時間帯：</p>
            <div class="info-value">
              <span class="d-flex align-center justify-start">
                <span class="ma-0 info-value">
                  {{
                    callDetails?.start_time
                      ? new Date(callDetails?.start_time).toLocaleTimeString(
                          [],
                          { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }
                        )
                      : "N/A"
                  }}
                  -
                  {{
                    callDetails?.end_time
                      ? new Date(callDetails?.end_time).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: false,
                        })
                      : "録音中"
                  }}
                </span>
              </span>
            </div>
          </div>
          <div class="border px-2 py-1">
            <p class="info-title">通話時間：</p>
            <p class="info-value">
              {{
                this.getDuration(callDetails?.start_time, callDetails?.end_time)
              }}
            </p>
          </div>
          <div class="border px-2 py-1">
            <p class="info-title">日付:</p>
            <p class="info-value">
              {{
                callDetails?.date
                  ? new Date(callDetails?.date).toLocaleDateString("en-CA")
                  : "N/A"
              }}
            </p>
          </div>
          <div class="border px-2 py-1" >
            <p class="info-title">コールID:</p>
            <p class="info-value">
              {{ callDetails?.call_id || "N/A" }}
            </p>
          </div>
          <div class="border px-2 py-1" >
            <p class="info-title">SIPペイロード：</p>
            <p class="info-value">
              SIP ペイロード（全 {{ callDetails?.sip_data?.length || 0 }} 件） -
              <span
                class="primary--text font-weight-medium text-decoration-underline cursor-pointer"
                @click="SIPDataModal = true; interactionUpdate(INTERACTION_POINT.CALL_DETAIL_SIP_PAYLOAD_VIEW, `すべて表示`, callDetails?.session_id)"
              >
                すべて表示
              </span>
            </p>
          </div>
        </div>
      </div>

      <!-- information section for analog projects -->
       <div class="information-div-analog mt-5 mb-5 pb-5" v-if="isAnalogProject">
        <template>
          <v-card outlined class="pa-4">
            <v-row>
              <v-col cols="12" sm="2" class="px-2 mb-2">
                <div class="info-title">
                  <v-icon small color="info-title" class="mr-1">mdi-phone</v-icon>
                  発信者番号
                </div>
                <p class="info-value">{{ handlePhoneNumberFormat(callDetails?.src_id) }}</p>
              </v-col>
        
              <v-col cols="12" sm="3" class="px-2 mb-2">
                <div class="info-title">
                  <v-icon small color="info-title" class="mr-1">mdi-account</v-icon>
                  着信先
                </div>
                <p class="info-value">{{ handlePhoneNumberFormat(callDetails?.dest_id) }}</p>
              </v-col>
        
              <v-col cols="12" sm="3" class="px-2 mb-2">
                <div class="info-title">
                  <v-icon small color="info-title" class="mr-1">mdi-domain</v-icon>
                  部門
                </div>
                <p class="info-value">{{ callDetails?.dest_department }}</p>
              </v-col>
        
              <v-col cols="12" sm="2" class="px-2 mb-2">
                <div class="info-title">
                  <v-icon small color="info-title" class="mr-1">mdi-calendar</v-icon>
                  日付
                </div>
                <p class="info-value">
                  {{
                    callDetails?.date
                      ? new Date(callDetails?.date).toLocaleDateString("en-CA")
                      : "N/A"
                  }}
                </p>
              </v-col>
        
              <v-col cols="12" sm="2" class="px-2 mb-2">
                <div class="info-title">
                  <v-icon small color="info-title" class="mr-1">mdi-clock-outline</v-icon>
                  通話時間
                </div>
                <p class="info-value">
                  {{
                    this.getDuration(callDetails?.start_time, callDetails?.end_time)
                  }}
                </p>
              </v-col>
            </v-row>
        
            <v-divider class="my-2" />
        
            <v-row align="center" class="px-2">
              <v-col class="d-flex align-center pt-3">
                <v-icon small color="info-title" class="mr-2">mdi-clock-time-four-outline</v-icon>
                <span class="info-value">
                  {{
                    callDetails?.start_time
                      ? new Date(callDetails?.start_time).toLocaleTimeString(
                          [],
                          { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }
                        )
                      : "N/A"
                  }}
                  -
                  {{
                    callDetails?.end_time
                      ? new Date(callDetails?.end_time).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: false,
                        })
                      : "録音中"
                  }}
                  <v-chip class="ml-2" small>
                    {{ callDetails?.call_status === "on_going" ? "録音中" : callDetails?.call_status === "finished" ? "完了" : callDetails?.call_status }}
                  </v-chip>
                </span>
              </v-col>
              <v-col class="text-right">
                <img
                :src="editIcon"
                class="cursor-pointer"
                alt="edit"
                @click="editCallDetails('analog_customer_info')"
              />
              </v-col>
            </v-row>
          </v-card>
        </template>
      </div>

      <!-- Summary section -->
      <div class="information-card mt-5" style="margin-top: 8px; position: relative">
        <div
          class="d-flex flex-wrap align-center justify-space-between"
          style="gap: 10px; margin-bottom: 10px"
        >
          <div class="d-flex align-center" style="gap: 10px">
            <p class="card-title" style="color: #194fa2">
              {{ callDetails?.conversation_title || "No Title" }}
            </p>
            <img
              class="cursor-pointer"
              :src="editIcon"
              alt="edit"
              @click="editCallDetails('title')"
            />
          </div>
          <div
            class="d-flex align-center justify-start"
            style="gap: 10px;"
            v-if="!isAnalogProject"
          >
            <div class="bar"></div>
            <div class="d-flex px-2">
              <p class="card-value" style="color: #194fa2; font-weight: 500">クライアント名称:</p>
              <p class="info-value ml-2">
                {{ this.client_info?.client_name || 'N/A' }}
              </p>
            </div>
            <div class="bar"></div>
            <div class="d-flex px-2">
              <p class="info-value" style="color: #194fa2; font-weight: 500">サービス名称:</p>
              <p class="info-value ml-2">
                <span>
                  {{ this.client_info?.service_name || 'N/A' }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="summary-div">
          <div
            class="information-card"
            style="
              background-color: white;
              overflow-y: hidden;
              scrollbar-width: thin;
            "
          >
            <div
              class="d-flex align-center justify-space-between"
              style="border-bottom: 1px solid #e2e2e2; padding-bottom: 6px"
            >
              <div class="d-flex align-center">
                <v-btn icon color="primary" @click="refreshSpeech">
                  <img :src="refreshSVG" alt="" width="28" />
                </v-btn>
                <div
                  style="
                    border-right: 1px solid #e2e2e2;
                    height: 20px;
                    margin: 0 6px;
                  "
                ></div>
                <span>スピーチの詳細</span>
              </div>

              <div v-if="presignedUrlLoader" class="me-2">
                <v-progress-circular
                  indeterminate
                  size="25"
                  color="primary"
                ></v-progress-circular>
              </div>
              <span
                v-else
                :class="`download-file d-flex align-center ${
                  callDetails?.audio_file_path
                    ? 'primary--text cursor-pointer'
                    : 'blackLight--text'
                }`"
                style="gap: 6px"
                @click="downloadFile(callDetails)"
              >
                <img :src="downloadIcon" alt="download" width="20" />
                <span> 音声ファイルをダウンロードする </span>
              </span>
            </div>
            <div class="final-text-tab">
              <div class="card-title">
                <v-tabs
                  v-model="speechTab"
                  background-color="transparent"
                  color="primary"
                  class="ma-0 pa-0"
                >
                  <v-tab
                    v-show="!isAnalogProject"
                    class="ma-0 pa-0"
                    style="line-height: 0"
                    >リアルタイム</v-tab
                  >
                  <div
                    v-show="!isAnalogProject"
                    style="border-right: 2px solid #e2e2e2; height: 22px"
                  ></div>
                  <v-tab class="ma-0 pa-0" style="line-height: 0">確定</v-tab>
                  <div
                    style="border-right: 2px solid #e2e2e2; height: 22px"
                  ></div>
                  <v-tab
                    :disabled="!callDetails?.audio_text"
                    class="ma-0 pa-0"
                    style="line-height: 0"
                    >匿名化</v-tab
                  >
                </v-tabs>
              </div>
              <!-- v-if="callDetails?.summary_text?.[selectedSummaryIndex]?.text && (speechTab ==  1 || speechTab ==  2)" -->

              <div
                v-if="
                  (speechTab == 1) ||
                  (speechTab == 2 && callDetails?.masked_audio_text)
                "
                class="d-flex align-center justify-end float-end download-copy-btn"
                style="top: 0px; right: 0px"
              >
                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="float-end copy_btn"
                      style="top: 0; position: sticky; right: 0; width: 24px; height: 24px"
                    >
                      <v-icon medium>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-if="speechTab == 1"
                      @click="forceReRunChorusTask"
                      :disabled="(!callDetails?.audio_file_path && !callDetails.chorus_task_id) || isAnyActionRunning"
                    >
                      <v-list-item-icon class="me-2">
                        <v-progress-circular
                          v-if="reRunLoading"
                          indeterminate
                          size="15"
                          width="2"
                        ></v-progress-circular>
                        <img v-else :src="reRunBtn" alt="regenerate" width="28" height="20" />
                      </v-list-item-icon>
                      <v-list-item-title>すべて再実行</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="speechTab == 1 && audioTextTab !== 0"
                      @click="improveTranscriptModal = true"
                      :disabled="(!callDetails?.audio_file_path && !callDetails.chorus_task_id) || isAnyActionRunning"
                    >
                      <v-list-item-icon class="me-2">
                        <v-progress-circular
                          v-if="improveLoading"
                          indeterminate
                          size="15"
                          width="2"
                        ></v-progress-circular>
                        <v-icon v-else small style="width: 20px; height: 20px">mdi-auto-fix</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>話者分離のみを再実行</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="speechTab == 1 && (callDetails?.audio_text)"
                      @click="regenerateAudioTextProcessed"
                      :disabled="isAnyActionRunning"
                    >
                      <v-list-item-icon class="me-2">
                        <img :src="dicRegenerationBtn" alt="regenerate" width="20" height="20" />
                      </v-list-item-icon>
                      <v-list-item-title>辞書適用</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="speechTab == 2 && callDetails?.masked_audio_text"
                      @click="
                        handleGenerateMaskedVersion(
                          callDetails?.audio_text,
                          'full-audio-text'
                        )
                      "
                      :disabled="isAnyActionRunning"
                    >
                      <v-list-item-icon class="me-2">
                        <img :src="regenerateBtn" alt="regenerate" width="20" height="20" />
                      </v-list-item-icon>
                      <v-list-item-title>再生成</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      @click="
                        copyToClipboard(
                          speechTab === 1 ? (audioTextTab === 0 
                          ? (callDetails?.audio_text_processed 
                          || callDetails?.audio_text)
                          : (callDetails?.audio_text_diarized_processed || callDetails?.audio_text_diarized || callDetails?.audio_text))
                          : callDetails?.masked_audio_text || ''
                        )
                      "
                      :disabled="(speechTab === 1 ? (audioTextTab === 0 ? !(callDetails?.audio_text_processed || callDetails?.audio_text) : !(callDetails?.audio_text_diarized_processed || callDetails?.audio_text_diarized)) : !callDetails?.masked_audio_text) || isAnyActionRunning"
                    >
                      <v-list-item-icon class="me-2">
                        <v-icon small style="width: 20px; height: 20px">mdi-content-copy</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>コピー</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      @click="
                        downloadTextFile(
                          speechTab == 1
                            ? `${callDetails?.session_id}-final-audio-text_${audioTextTab === 0 ? 'plain' : 'diarized'}.txt`
                            : `${callDetails?.session_id}-final-audio-text-masked-version.txt`,
                          speechTab === 1 ? (audioTextTab === 0 
                          ? (callDetails?.audio_text_processed 
                          || callDetails?.audio_text)
                          : (callDetails?.audio_text_diarized_processed || callDetails?.audio_text_diarized || callDetails?.audio_text))
                            : callDetails?.masked_audio_text
                        );
                        interactionUpdate(
                          speechTab == 1
                            ? INTERACTION_POINT.CALL_DETAIL_DOWNLOAD_AUDIO_TEXT
                            : INTERACTION_POINT.CALL_DETAIL_DOWNLOAD_AUDIO_MASKED_TEXT,
                          'ダウンロードアイコン',
                          callDetails?.session_id
                        )
                      "
                      :disabled="(speechTab === 1 ? (audioTextTab === 0 ? !(callDetails?.audio_text_processed || callDetails?.audio_text) : !(callDetails?.audio_text_diarized_processed || callDetails?.audio_text_diarized)) : !callDetails?.masked_audio_text) || isAnyActionRunning"
                    >
                      <v-list-item-icon class="me-2">
                        <v-icon small style="width: 20px; height: 20px">mdi-download</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>ダウンロード</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <div v-if="speechLoading">
              <SpeechSkeleton />
            </div>
            <div
              v-else
              ref="speechContainer"
              class="information-card mt-1 speech-text content-section"
            >
              <template v-if="speechTab === 1">
                <div class="tabs-float">
                  <v-tabs
                    v-model="audioTextTab"
                    background-color="transparent"
                    color="primary"
                    class="ma-0 pa-0"
                    grow
                    slider-color="#069ea8"
                    active-class="text-active-tab"
                  >
                    <v-tab class="ma-0 pa-0 small-tabs" style="line-height: 1; font-size: 12px;">
                      オリジナル
                    </v-tab>
                    <div
                      style="border-right: 1px solid #e2e2e2; height: 24px"
                    ></div>
                    <v-tab 
                      class="ma-0 pa-0 small-tabs" 
                      style="line-height: 1; font-size: 12px;"
                    >
                      話者分離
                    </v-tab>
                  </v-tabs>
                </div>
                <div
                  v-if="callDetails?.audio_text || callDetails?.audio_text_diarized"
                  class="full-audio-text-content"
                >
                  <div v-if="audioTextTab === 0">
                    <template v-if="callDetails?.audio_text">
                      <VueMarkdown :key="'original-tab'">
                      {{ 
                        callDetails?.audio_text_processed ? 
                          callDetails.audio_text_processed
                          .replace(/(^|\s)(\b(?!http|https)\w+):/g, "$1**$2**:")
                          .replace(/([。.!?])/g, "$1\n")
                        : callDetails.audio_text
                          .replace(/(^|\s)(\b(?!http|https)\w+):/g, "$1**$2**:")
                          .replace(/([。.!?])/g, "$1\n")
                      }}
                      </VueMarkdown>
                    </template>
                    <div v-else class="full-audio-text-content">
                      <p class="centered-text">
                        確定した文字起こしを生成中です。しばらくお待ちください。
                      </p>
                    </div>
                  </div>
                  <template v-else-if="audioTextTab === 1">
                    <div v-if="callDetails && !('audio_text_diarized' in callDetails)">
                      <p class="full-audio-text-content centered-text">
                        利用不可
                      </p>
                    </div>
                    <div v-else-if="callDetails?.audio_text_diarized === null">
                      <p class="full-audio-text-content centered-text">
                        最終的なスピーカー別文字起こしを生成していますので、お待ちください。
                      </p>
                    </div>
                    <div v-else-if="callDetails?.audio_text_diarized">
                      <VueMarkdown :key="'diarized-tab'">
                        {{
                          formatDiarizedText(callDetails?.audio_text_diarized_processed 
                          || callDetails?.audio_text_diarized)
                        }}
                      </VueMarkdown>
                    </div>
                  </template>
                </div>
                <div v-else-if="!callDetails?.chorus_task_id && !callDetails?.audio_text && !callDetails?.audio_text_processed && !callDetails?.audio_text_diarized && !callDetails?.audio_text_diarized_processed" class="full-audio-text-content">
                  <p class="text-center centered-text">
                    文字起こしが失敗しました。再実行ボタンをクリックして文字起こしを生成してください。
                    </p>
                </div>
                <div v-else-if="callDetails?.call_status === 'on_going'" class="full-audio-text-content">
                  <p class="text-center centered-text">
                  確定した文字起こしは通話終了後利用可能になります。                </p>
                </div>
                <div v-else class="full-audio-text-content">
                  <p class="text-center centered-text">
                    {{ callDetails.audio_text_diarized === undefined && audioTextTab === 1 ? "利用不可" :(callDetails.audio_text_diarized === null && audioTextTab === 1 && chorusFailureCount < 3) ? '話者分離された文字起こしはまだ生成されていません。' : chorusFailureCount >= 3 ? "文字起こしが失敗しました。再実行ボタンをクリックして文字起こしを生成してください。" : '確定した文字起こしはまだ生成されていません。'
                    }}
                  </p>
                </div>
              </template>
              <template v-if="speechTab === 2">
                <MaskedTextView
                  :genarateMaskedLoader="genarateMaskedLoader"
                  :callDetails="callDetails"
                  @generate="handleGenerateMaskedVersion"
                  :text="callDetails?.audio_text"
                  :maskedText="callDetails?.masked_audio_text"
                  :type="'full-audio-text'"
                />
              </template>
              <template v-else-if="speechTab === 0">
                <SocketText
                  :displayMessages="displayMessages"
                  :connected="connected"
                />
              </template>
            </div>
            <span class="process_time_scroll"
              v-if="(callDetails?.audio_text || callDetails?.audio_text_diarized) && speechTab == 1">
              {{
                audioTextTab == 0 ?
                  (callDetails?.audio_text_processing_time && callDetails?.audio_text) ? (callDetails?.audio_text_processing_time).toFixed(2) + 's' :
                    ''
                  :
                  (callDetails?.audio_text_diarized_processing_time && callDetails?.audio_text_diarized) ?
                    (callDetails?.audio_text_diarized_processing_time).toFixed(2) + 's' : ''
              }}
            </span>
            <span class="process_time_scroll" v-if="(callDetails?.masked_audio_text) && speechTab == 2">
              {{ 
                callDetails?.masking_time ? (callDetails?.masking_time).toFixed(2) + 's' : ''
              }}
            </span>
          </div>
          <div
            class="information-card"
            style="overflow-y: hidden; scrollbar-width: thin"
          >
            <div
              class="d-flex align-center justify-space-between"
              style="border-bottom: 1px solid #e4e4e4; padding-bottom: 6px"
            >
              <div class="d-flex align-center">
                <div class="card-title">要約の詳細</div>
              </div>

              <!-- select a GPT Profile -->
              <v-menu
                offset-y
                :close-on-content-click="false"
                transition="scale-transition"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <button text v-on="on" class="generate-summary-btn">
                    新しい要約を作成
                  </button>
                </template>
                <v-card>
                  <v-list>
                    <v-list-item
                      v-for="(profile, index) in gptProfiles"
                      :key="index"
                      @click="generateNewSummary(profile.id)"
                    >
                      <v-list-item-title>
                        {{ profile.name }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </div>
            <div
              class="information-card mt-1 summary-text"
              style="display: flex; flex-direction: column"
            >
              <div v-if="generateSummaryLoader">
                <SummarySkeleton />
              </div>
              <v-row v-else class="summary-text-div">
                <v-col cols="12" md="2" class="summary-profile">
                  <span
                    style="
                      border-bottom: 0.5px solid #e4e4e4;
                      padding: 0 6px 4px 6px;
                      font-weight: 600;
                      font-size: 12px;
                      color: #3f4652;
                    "
                  >
                    作成済みプロファイル:
                  </span>
                  <span
                    style="justify-content: start"
                    v-for="(summary, index) in callDetails?.summary_text"
                    :key="index"
                    :class="`summary-profile-tab ${
                      selectedSummaryIndex === index
                        ? 'summary-profile-tab-active'
                        : ''
                    }`"
                    @click="selectedSummaryIndex = index"
                  >
                    {{ getGptProfileName(summary.gpt_profile) }}
                  </span>
                </v-col>
                <v-col
                  v-if="callDetails?.summary_text"
                  cols="12"
                  lg="10"
                  class="summary-text-sinlge"
                  style="position: static"
                >
                  <div class="summary_latest_header">
                    <div class="card-title summary_latest_tab">
                      <v-tabs
                        v-model="summaryLatestTab"
                        background-color="transparent"
                        color="primary"
                        class="ma-0 pa-0"
                      >
                        <v-tab class="ma-0 pa-0" style="line-height: 0"
                          >要約</v-tab
                        >
                        <div
                          style="border-right: 2px solid #e2e2e2; height: 20px"
                        ></div>
                        <v-tab class="ma-0 pa-0" style="line-height: 0"
                          >匿名化</v-tab
                        >
                      </v-tabs>
                    </div>
                    <div
                      v-if="
                        callDetails?.summary_text?.[selectedSummaryIndex]?.text
                      "
                      class="d-flex align-center justify-end download-copy-btn"
                      style="position: absolute; right: 6px"
                    >
                      <v-btn
                        v-if="
                          callDetails?.summary_text?.[selectedSummaryIndex] &&
                          summaryLatestTab == 0
                        "
                        icon
                        @click="
                          openConversationHistory(
                            callDetails?.summary_text?.[selectedSummaryIndex]
                          )
                        "
                      >
                        <img :src="historyIcon" alt="history" width="30" />
                      </v-btn>
                      <v-btn
                        icon
                        v-if="
                          summaryLatestTab == 1 &&
                          callDetails?.summary_text?.[selectedSummaryIndex]
                            ?.masked_text
                        "
                        @click="
                          handleGenerateMaskedVersion(
                            callDetails?.summary_text?.[selectedSummaryIndex]
                              ?.text,
                            'selectedSummaryIndex'
                          )
                        "
                        class="float-end copy_btn"
                        style="top: 0; position: sticky; right: 0"
                      >
                        <img :src="regenerateBtn" alt="regenerate" width="30" />
                      </v-btn>
                      <v-btn
                        icon
                        v-if="
                          (summaryLatestTab == 0 &&
                            callDetails?.summary_text?.[selectedSummaryIndex]
                              ?.text) ||
                          (summaryLatestTab == 1 &&
                            callDetails?.summary_text?.[selectedSummaryIndex]
                              ?.masked_text)
                        "
                        @click="
                          copyToClipboard(
                            summaryLatestTab == 0
                              ? callDetails?.summary_text?.[
                                  selectedSummaryIndex
                                ]?.text
                              : callDetails?.summary_text?.[
                                  selectedSummaryIndex
                                ]?.masked_text
                          )
                        "
                      >
                        <img :src="copyIconWhite" alt="copy" width="30" />
                      </v-btn>
                      <!-- download text btn  -->
                      <v-btn
                        icon
                        v-if="
                          (summaryLatestTab == 0 &&
                            callDetails?.summary_text?.[selectedSummaryIndex]
                              ?.text) ||
                          (summaryLatestTab == 1 &&
                            callDetails?.summary_text?.[selectedSummaryIndex]
                              ?.masked_text)
                        "
                        @click="
                          downloadTextFile(
                            summaryLatestTab == 0
                              ? `${callDetails?.session_id}-summary.txt`
                              : `${callDetails?.session_id}-summrary-masked-version.txt`,
                            summaryLatestTab == 0
                              ? callDetails?.summary_text?.[
                                  selectedSummaryIndex
                                ]?.text
                              : callDetails?.summary_text?.[
                                  selectedSummaryIndex
                                ]?.masked_text
                          );
                          interactionUpdate(
                            summaryLatestTab == 0
                              ? INTERACTION_POINT.CALL_DETAIL_DOWNLOAD_AUDIO_SUMMARY
                              : INTERACTION_POINT.CALL_DETAIL_DOWNLOAD_AUDIO_SUMMARY_MASKED,
                            'ダウンロードアイコン',
                            callDetails?.session_id
                          )
                        "
                      >
                        <img
                          :src="downloadWhiteIcon"
                          alt="download"
                          width="30"
                        />
                      </v-btn>
                    </div>
                  </div>
                  <template v-if="summaryLatestTab == 0">
                    <VueMarkdown
                      class="summary_contant"
                      v-if="
                        callDetails?.summary_text &&
                        callDetails?.summary_text?.[selectedSummaryIndex]?.text
                      "
                      :source="
                        callDetails?.summary_text?.[
                          selectedSummaryIndex
                        ]?.text.replace(
                          /(^|\s)(\b(?!http|https)\w+):/g,
                          '$1**$2**:'
                        )
                      "
                    />
                    <span class="process_time_scroll" v-if="callDetails?.summary_text &&
                      callDetails?.summary_text?.[selectedSummaryIndex]?.text">
                        {{ 
                          callDetails?.summary_text?.[selectedSummaryIndex]?.process_time ? (callDetails?.summary_text?.[selectedSummaryIndex]?.process_time).toFixed(2) + 's' : ''
                        }}
                    </span>
                  </template>
                  <template v-if="summaryLatestTab == 1">
                    <MaskedTextView
                      :genarateMaskedLoader="genarateSummaryMaskedLoader"
                      :callDetails="callDetails"
                      @generate="handleGenerateMaskedVersion"
                      :text="
                        callDetails?.summary_text &&
                        callDetails?.summary_text?.[selectedSummaryIndex]?.text
                      "
                      :maskedText="
                        callDetails?.summary_text &&
                        callDetails?.summary_text?.[selectedSummaryIndex]
                          ?.masked_text
                      "
                      :type="'selectedSummaryIndex'"
                      :key="selectedSummaryIndex"
                    />
                    <span class="process_time_scroll" v-if="callDetails?.summary_text &&
                      callDetails?.summary_text?.[selectedSummaryIndex]?.masked_text">
                      {{ 
                        callDetails?.summary_text?.[selectedSummaryIndex]?.masking_time ? (callDetails?.summary_text?.[selectedSummaryIndex]?.masking_time).toFixed(2) + 's' : ''
                      }}
                    </span>
                  </template>
                  <!-- Fixed bottom section -->
                  <div
                    v-if="summaryLatestTab != 1"
                    class="d-flex summary_update_field"
                    style="
                      position: sticky;
                      bottom: 0;
                      left: 0;
                      padding: 0 6px;
                      background-color: white;
                      z-index: 1;
                    "
                  >
                    <v-text-field
                      v-model="modifiedSummaryQuery"
                      outlined
                      dense
                      hide-details
                      placeholder="この要約を編集"
                      @keydown="
                        handleModifySummary(
                          $event,
                          callDetails?.summary_text?.[selectedSummaryIndex],
                          selectedSummaryIndex
                        )
                      "
                      @compositionstart="isComposing = true"
                      @compositionend="isComposing = false"
                      style="width: calc(100% - 48px)"
                    >
                    </v-text-field>
                    <v-btn
                      class="ms-2"
                      icon
                      @click="
                        modifySummary(
                          callDetails?.summary_text?.[selectedSummaryIndex],
                          selectedSummaryIndex
                        )
                      "
                      color="primary"
                    >
                      <img :src="sendIcon" alt="send" width="64" />
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
      <template>
        <v-row justify="center">
          <v-dialog
            v-model="generateNewSummaryModal"
            persistent
            max-width="600"
          >
            <v-card>
              <v-card-title class="text-h5">
                <span>
                  このプロファイル
                  <span class="font-weight-bold primary--text"
                    >「{{
                      this.gptProfiles.find(
                        (profile) => profile.id === genaratedGptProfile
                      )?.name
                    }}」</span
                  >
                  で新しい要約を作成してもよろしいですか？
                </span>
              </v-card-title>
              <v-card-text
                v-if="
                  Array.isArray(callDetails?.summary_text) &&
                  callDetails.summary_text?.find(
                    (summary) => summary.gpt_profile === genaratedGptProfile
                  )
                "
              >
                <p>
                  <small v-if="callDetails?.summary_text">
                    {{
                      callDetails?.summary_text?.find(
                        (summary) => summary.gpt_profile === genaratedGptProfile
                      )
                        ? `この[${
                            this.gptProfiles.find(
                              (profile) => profile.id === genaratedGptProfile
                            )?.name
                          }]で新しい要約を作成すると、既存の要約が上書きされます`
                        : ""
                    }}
                  </small>
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="error"
                  text
                  @click="generateNewSummaryModal = false"
                >
                  キャンセル
                </v-btn>
                <v-btn color="success" text @click="generateSummary()">
                  要約を作成
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <v-navigation-drawer
        v-model="conversationHistoryModal"
        right
        app
        width="680"
        temporary
        style="background: white; padding: 20px 28px"
      >
        <div>
          <div
            class="d-flex justify-space-between align-center"
            style="padding-bottom: 6px"
          >
            <span class="offset-title"> 要約の変更履歴 </span>
            <div style="border: 0.5px solid #e2e8f0">
              <v-btn icon @click="closeSummaryHistoryModal()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
          <v-divider></v-divider>
          <div
            style="
              max-height: 89vh;
              overflow-y: auto;
              margin-top: 10px;
              scrollbar-width: thin;
            "
            ref="chatContainer"
          >
            <v-row v-if="conversationHistoryLoader">
              <v-col cols="12">
                <div v-for="i in 7" :key="i">
                  <v-skeleton-loader type="list-item-three-line" />
                </div>
              </v-col>
            </v-row>
            <v-row v-else class="ma-0 pa-0">
              <v-row class="ma-0 pa-0">
                <v-col
                  cols="12"
                  v-for="i in conversationHistory?.length"
                  :key="
                    conversationHistory?.[conversationHistory?.length - i]?.id
                  "
                  class="ma-0 pa-0"
                >
                  <v-row class="ma-0 pa-0 align-start">
                    <v-card
                      cols="12"
                      class="mb-3 elevation-0 summary-history-v-card"
                      style="
                        background: #ffffff4d;
                        border: 1px solid #e2e8f0;
                        border-radius: 8px;
                        padding: 10px;
                        color: #3f4652;
                      "
                    >
                      <div class="summery_history_tab">
                        <div
                          class="d-flex flex-col items-start justify-space-between ma-0 pb-0 pe-0 flex-direction-row align-item-flex-start"
                          style="border-bottom: 1px solid #e2e8f0"
                        >
                          <div>
                            <span
                              style="
                                font-weight: 500;
                                font-size: 16px;
                                color: #194fa2;
                              "
                            >
                              要約
                              <span>{{
                                totalCoverstationHistory -
                                conversationHistory?.length +
                                i
                              }}</span>
                            </span>
                          </div>
                          <div class="float-end">
                            <small class="d-flex align-center">
                              {{
                                new Date(
                                  conversationHistory?.[
                                    conversationHistory?.length - i
                                  ]?.created_at
                                ).toLocaleString()
                              }}
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="history_tab-btn">
                        <div class="card-title" style="height: 40px">
                          <v-tabs
                            v-model="summaryTabIndexes[i]"
                            background-color="transparent"
                            color="primary"
                            class="ma-0 pa-0"
                          >
                            <v-tab class="ma-0 pa-0" style="line-height: 0"
                              >要約</v-tab
                            >
                            <div
                              style="
                                border-right: 2px solid #e2e2e2;
                                height: 20px;
                              "
                            ></div>
                            <v-tab class="ma-0 pa-0" style="line-height: 0"
                              >匿名化</v-tab
                            >
                          </v-tabs>
                        </div>
                        <div
                          class="d-flex align-center justify-end float-end download-copy-btn"
                        >
                          <v-btn
                            v-if="summaryTabIndexes[i] == 0"
                            icon
                            @click="
                              redirectDetailsPage(
                                conversationHistory?.[
                                  conversationHistory?.length - i
                                ]?.conversation_id
                              )
                            "
                          >
                            <img :src="infoIcon" alt="info" width="30" />
                          </v-btn>
                          <v-btn
                            icon
                            v-if="
                              summaryTabIndexes[i] == 1 &&
                              conversationHistory?.[
                                conversationHistory?.length - i
                              ]?.masked_response
                            "
                            @click="
                              handleGenerateMaskedVersion(
                                conversationHistory?.[
                                  conversationHistory?.length - i
                                ]?.response,
                                'conversationHistory',
                                i
                              )
                            "
                            class="float-end copy_btn"
                            style="top: 0; position: sticky; right: 0"
                          >
                            <img
                              :src="regenerateBtn"
                              alt="regenerate"
                              width="30"
                            />
                          </v-btn>
                          <v-btn
                            icon
                            v-if="
                              (summaryTabIndexes[i] == 0 &&
                                conversationHistory?.[
                                  conversationHistory?.length - i
                                ]?.response) ||
                              (summaryTabIndexes[i] == 1 &&
                                conversationHistory?.[
                                  conversationHistory?.length - i
                                ]?.masked_response)
                            "
                            @click="
                              copyToClipboard(
                                summaryTabIndexes[i] == 0
                                  ? conversationHistory?.[
                                      conversationHistory?.length - i
                                    ]?.response
                                  : conversationHistory?.[
                                      conversationHistory?.length - i
                                    ]?.masked_response
                              )
                            "
                            class="float-end"
                          >
                            <img :src="copyIconWhite" alt="copy" width="30" />
                          </v-btn>
                          <v-btn
                            icon
                            v-if="
                              (summaryTabIndexes[i] == 0 &&
                                conversationHistory?.[
                                  conversationHistory?.length - i
                                ]?.response) ||
                              (summaryTabIndexes[i] == 1 &&
                                conversationHistory?.[
                                  conversationHistory?.length - i
                                ]?.masked_response)
                            "
                            @click="
                              downloadTextFile(
                                summaryTabIndexes[i] == 0
                                  ? `${callDetails?.session_id}-summary-${i}.txt`
                                  : `${callDetails?.session_id}-summary-${i}-masked.txt`,
                                summaryTabIndexes[i] == 0
                                  ? conversationHistory?.[
                                      conversationHistory?.length - i
                                    ]?.response
                                  : conversationHistory?.[
                                      conversationHistory?.length - i
                                    ]?.masked_response
                              )
                            "
                            class="float-end"
                          >
                            <img
                              :src="downloadWhiteIcon"
                              alt="download"
                              width="30"
                            />
                          </v-btn>
                        </div>
                      </div>

                      <template v-if="summaryTabIndexes[i] == 0">
                        <div
                          class="conversation_index_content"
                          v-if="
                            conversationHistory?.[
                              conversationHistory?.length - i
                            ]?.response
                          "
                        >
                          <VueMarkdown>
                            {{
                              conversationHistory?.[
                                conversationHistory?.length - i
                              ]?.response?.replace(
                                /(^|\s)(\b(?!http|https)\w+):/g,
                                "$1**$2**:"
                              )
                            }}
                          </VueMarkdown>
                          <span class="process_time" v-if="conversationHistory?.[
                              conversationHistory?.length - i
                            ]?.process_time">
                            {{ 
                              (conversationHistory?.[
                              conversationHistory?.length - i
                            ]?.process_time).toFixed(2) + 's'
                             }}
                          </span>
                        </div>
                      </template>
                      <template v-if="summaryTabIndexes[i] == 1">
                        <MaskedTextView
                          :genarateMaskedLoader="
                            conversationIndexloading[i - 1]
                          "
                          :callDetails="callDetails"
                          @generate="handleGenerateMaskedVersion"
                          :text="
                            conversationHistory?.[
                              conversationHistory?.length - i
                            ]?.response
                          "
                          :maskedText="
                            conversationHistory?.[
                              conversationHistory?.length - i
                            ]?.masked_response
                          "
                          :type="'conversationHistory'"
                          :index="i"
                        />
                      </template>
                    </v-card>
                    <!-- <v-col cols="2"></v-col> -->
                  </v-row>
                </v-col>
              </v-row>
            </v-row>
          </div>
        </div>
      </v-navigation-drawer>
      <template v-if="SIPDataModal">
        <v-dialog v-model="SIPDataModal" width="calc(100% - 20px)">
          <SIPDataModalView
            :SIPData="callDetails?.sip_data || []"
            :closeSIPDataModal="closeSIPDataModal"
          />
        </v-dialog>
      </template>
      <template>
        <v-row justify="center">
          <v-dialog v-model="deleteModal" persistent max-width="500">
            <v-card class="custom-modal-card delete-call-modal-main">
              <!-- Title -->
              <v-card-title class="custom-modal-title">
                削除の確認
              </v-card-title>

              <!-- Body -->
              <v-card-text class="custom-modal-body">
                この通話データを完全に削除します。<br />
                続行しますか？
              </v-card-text>

              <!-- Footer -->
              <v-card-actions class="custom-modal-footer">
                <v-btn class="btn-close" text @click="deleteModal = false">
                  キャンセル
                </v-btn>
                <v-btn
                  class="btn-understood"
                  depressed
                  color="red"
                  @click="deleteConfirm"
                >
                  削除する
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <v-navigation-drawer
        v-model="callEditedModal"
        right
        app
        width="680"
        temporary
        style="
          padding: 20px 28px;
          background: #ffffffe5;
          backdrop-filter: blur(20px);
        "
      >
        <CallEditModal
          :callEditedInfo="callEditedInfo"
          :closeCallEditedModal="closeCallEditedModal"
          :showSnackbar="showSnackbar"
          :getCallInformation="getCallInformation"
        />
      </v-navigation-drawer>
      <v-dialog v-model="showFullText" max-width="500">
        <v-card>
          <v-card-title class="justify-space-between align-center"
            >Full Info

            <v-btn icon @click="showFullText = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>{{ fullText }}</v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import {
  RETRIEVE_CALL_DETAILS,
  UPDATE_CALL_DETAIL,
  RETRIEVE_GPT_PROFILES,
  RETRIEVE_PRESIGNED_URL,
  RETRIEVE_GPT_CONVERSATION_SUMMARY,
  RETRIEVE_CONVERSATION_HISTORY,
  GENERATE_MASKED_TRANSCRIPTION,
  SAVE_MASKED_TRANSCRIPTION,
  UPDATE_MASKED_CONVERSATION,
  DELETE_CALL_DETAIL,
  GET_CHORUS_TASK_STATUS,
  CREATE_TRANSCRIPTION,
  RE_RUN_CHORUS_TASK,
  SWITCH_PROJECT,
  VALIDATE_REMAINING_ENTRIES
} from "@/store/_actiontypes";
import { mapActions, mapGetters } from "vuex";
import VueMarkdown from "vue-markdown";
import getEnv from "@/config/env";
import CryptoJS from "crypto-js";
import logo from "@/assets/images/logo.png";
import historyIcon from "@/assets/images/history.svg";
import copyIcon from "@/assets/images/copy.svg";
import copyIconWhite from "@/assets/images/copy_white.svg";
import regenerateBtn from "@/assets/images/regenerate.svg";
import dicRegenerationBtn from "@/assets/images/dictionaryRegenerate.svg";
import reRunBtn from "@/assets/images/re_run.svg";
import infoIcon from "@/assets/images/info.svg";
import dashboardIcon from "@/assets/images/dashboard.svg";
import documentationsIcon from "@/assets/images/documentations.svg";
import editIcon from "@/assets/images/edit.svg";
import downloadIcon from "@/assets/images/download.svg";
import downloadWhiteIcon from "@/assets/images/download_white.svg";
import sendIcon from "@/assets/images/send.svg";
import leftIcon from "@/assets/images/left.svg";
import incomingCallIcon from "@/assets/images/incoming.svg";
import outgoingCallIcon from "@/assets/images/outgoing.svg";
import refreshSVG from "@/assets/images/refresh.svg";
import NewCallSkeleton from "@/components/NewCallSkeleton.vue";
import SpeechSkeleton from "@/components/SpeechSkeleton.vue";
import SummarySkeleton from "@/components/SummarySkeleton.vue";
import SIPDataModalView from "@/components/SIPDataModalView.vue";
import SocketText from "@/components/SocketText.vue";
import CallEditModal from "@/components/CallEditModal.vue";
import { getCurrentUser, interactionUpdate } from "@/helpers/helper";
import MaskedTextView from "@/components/MaskedTextView.vue";
import deleteIcon from "@/assets/images/Delete.svg";
import { getCounselorNameBackfillPatch } from "@/helpers/SoftPhone_Information";
import { findClientsFromSipData } from '@/helpers/Client_Information';
import { getDestFullPhoneName } from "@/helpers/Destination_Information";
import { INTERACTION_POINT } from '@/global/_constants';
import PageNotFound from "./PageNotFound.vue";

export default {
  name: "CallDetailsPage",
  components: {
    VueMarkdown,
    NewCallSkeleton,
    SpeechSkeleton,
    SummarySkeleton,
    SIPDataModalView,
    SocketText,
    CallEditModal,
    MaskedTextView,
    PageNotFound,
  },
  data: () => ({
    interactionUpdate,
    INTERACTION_POINT,
    userName: "N/A",
    userEmail: "N/A",
    userDepartments: [],
    logo,
    isComposing: false,
    historyIcon,
    copyIcon,
    copyIconWhite,
    regenerateBtn,
    dicRegenerationBtn,
    reRunBtn,
    infoIcon,
    dashboardIcon,
    documentationsIcon,
    editIcon,
    downloadIcon,
    downloadWhiteIcon,
    sendIcon,
    leftIcon,
    incomingCallIcon,
    outgoingCallIcon,
    refreshSVG,
    editedDestinationInfo: "",
    fullLoading: false,
    speechLoading: false,
    callDetails: null,
    FullSipData: false,
    gptProfiles: [],
    isEditSourceInfo: false,
    isEditDestInfo: false,
    isEditTitle: false,
    isEditSourcePin: false,
    snackbar: false,
    snackbarColor: "",
    snackbarMessage: "",
    editedSourceInfo: "",
    editedDestInfo: "",
    editedConversationTitle: "",
    editedSourcePin: "",
    callDetailsInterval: null,
    callDurationInterval: null,
    callDetailsLiveDuration: "",
    platformUrl: getEnv("VUE_APP_CONSOLE_WEB_URL"),
    streamUrl: getEnv("VUE_APP_STREAM_URL"),
    defaultUser: getEnv("VUE_APP_DEFAULT_USER_ID"),
    defaultMember: getEnv("VUE_APP_DEFAULT_MEMBER_ID"),
    token: "",
    presignedUrlLoader: false,
    genarateMaskedLoader: false,
    genarateSummaryMaskedLoader: false,
    genaratedGptProfile: null,
    generateSummaryLoader: false,
    modifiedSummaryQuery: "",
    generateNewSummaryModal: false,
    conversationHistoryModal: false,
    conversationHistory: [],
    totalCoverstationHistory: 0,
    conversationHistoryLoader: false,
    selectedSummaryIndex: 0,
    SIPDataModal: false,
    speechTab: 0,
    summaryTab: 0,
    callEditedInfo: {},
    callEditedModal: false,
    showFullText: false,
    fullText: "",
    socket: null,
    displayMessages: [],
    messages: [],
    connected: false,
    isFirstLoad: true,
    summaryTabIndexes: {},
    summaryHistoryLoaderIndexes: {},
    summaryLatestTab: 0,
    conversationIndexloading: [],
    deleteIcon,
    deleteModal: false,
    client_info: null,
    audioTextTab: 0,
    chorusPollingInterval: null,
    reRunLoading: false,
    chorusTaskStatus: null,
    chorusStatusModal: false,
    chorusStatusMessage: "",
    chorusFailureCount: 0,
    improveTranscriptModal: false,
    improveLoading: false,
    activeChorusTaskType: null,
  }),
  mounted() {
    this.getGptProfile();
    this.fullLoading = true;
    this.getCallInformation();
    // this.connectWebSocket();
    // this.conversationIndexloading = this.summaries.map(() => false);
  },
  beforeUnmount() {
    if (this.socket) {
      this.socket.close();
    }
    this.stopChorusPolling();
  },
  computed: {
    ...mapGetters("account", ["userProfile", "isAdmin"]),
    ...mapGetters("project", [
      "activeProjectId",
      "activeAccountId",
      "activeMaskProfileId",
      "isAnalogProject",
      "activeProjectKey",
      "accessibleEntries",
    ]),
    isAnyActionRunning() {
      return this.reRunLoading || this.improveLoading || this.speechLoading || this.genarateMaskedLoader || this.improveTranscriptModal;
    },
  },
  watch: {
    isAnalogProject: {
      handler(isAnalog) {
        if (isAnalog) {
          this.speechTab = 1;
        }
      },
      immediate: true,
    },
    "callDetails.session_id": {
      handler(newSessionId) {
        if (newSessionId) {
          this.connectWebSocket();
        }
      },
      immediate: true,
    },
    "callDetails.start_time": {
      handler: function (val) {
        if (val) {
          this.callDurationInterval = setInterval(() => {
            this.updateLiveDuration(val);
          }, 1000); // 1 second
        }
      },
      immediate: true,
    },
    conversationHistory: {
      // scroll to bottom chatContainer
      handler() {
        this.$nextTick(() => {
          this.$refs.chatContainer.scrollTop =
            this.$refs.chatContainer.scrollHeight;
        });
      },
    },
    messages() {
      this.scrollToBottomSpeech();
    },
    displayMessages() {
      this.scrollToBottomSpeech();
    },
  },
  methods: {
    ...mapActions("call", [
      RETRIEVE_CALL_DETAILS,
      UPDATE_CALL_DETAIL,
      SAVE_MASKED_TRANSCRIPTION,
      DELETE_CALL_DETAIL,
      GET_CHORUS_TASK_STATUS,
      CREATE_TRANSCRIPTION,
      RE_RUN_CHORUS_TASK
    ]),
    ...mapActions("gpt", [
      RETRIEVE_GPT_PROFILES,
      RETRIEVE_GPT_CONVERSATION_SUMMARY,
      RETRIEVE_CONVERSATION_HISTORY,
      GENERATE_MASKED_TRANSCRIPTION,
      UPDATE_MASKED_CONVERSATION,
    ]),
    ...mapActions("download", [RETRIEVE_PRESIGNED_URL]),
    ...mapActions("project", [SWITCH_PROJECT, VALIDATE_REMAINING_ENTRIES]),
    // ...mapActions("gpt", [GENERATE_MASKED_TRANSCRIPTION]),
    formatDiarizedText(text) {
      if (!text) return "";
      return text.replace(/(SPEAKER_\d+):/g, '\n\n**$1:**').trim();
    },
    async regenerateAudioTextProcessed() {
      if(this.speechLoading) {
        this.showSnackbar("処理中です。しばらくお待ちください。", "warning");
        return;
      }
      this.speechLoading = true;
      try {
        await this.updateCallDetail('regenerate_audio_text_processed', true, false, { 'use_dictionary': true });
        interactionUpdate(INTERACTION_POINT.REGENERATE_AUDIO_TEXT_PROCESSED, `アイコンを再生成`, this.callDetails?.session_id);
        await this.getCallInformation();
      } catch (error) {
        console.error("Error audio text generate:", error);
      } finally {
        this.speechLoading = false;
      }
    },
    connectWebSocket() {
      if (this.isAnalogProject) return;

      const wsUrl = `${this.streamUrl}${this.callDetails?.session_id}`;
      this.socket = new WebSocket(wsUrl);

      this.socket.onopen = () => {
        console.log("WebSocket connected");
        this.connected = true;
      };

      this.socket.onmessage = (event) => {
        this.scrollToBottomSpeech();
        if (event.data.startsWith("[PAST_MESSAGES]")) {
          const pastMessages = event.data
            .replace("[PAST_MESSAGES]", "")
            .split("\n");
          // **Only update past messages if it's the first load**
          if (this.isFirstLoad) {
            this.messages = [...pastMessages];
            this.displayMessages = [...pastMessages]; // Render instantly
            this.isFirstLoad = false; // Mark as loaded
          }
        } else {
          this.messages.push(event.data);
          this.animateTypewriter(event.data);
        }

        this.scrollToBottomSpeech();
      };

      this.socket.onclose = () => {
        console.log("WebSocket disconnected, reconnecting...");
        this.connected = false;
        setTimeout(this.connectWebSocket, 3000);
      };

      this.socket.onerror = (error) => {
        console.error("WebSocket error:", error);
      };
    },
    animateTypewriter(message) {
      let index = this.messages.length - 1;
      this.displayMessages[index] = "";

      let i = 0;
      const interval = setInterval(() => {
        if (i < message.length) {
          this.$set(
            this.displayMessages,
            index,
            this.displayMessages[index] + message[i]
          );
          i++;
        } else {
          clearInterval(interval);
        }
      }, 50);
    },
    getGptProfile() {
      this.RETRIEVE_GPT_PROFILES()
        .then((response) => {
          if (response) {
            this.gptProfiles = response;
          }
        })
        .catch((error) => {
          console.error("Error fetching GPT profiles:", error);
        });
    },
    showSnackbar(message, color) {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    async retrieveCallAcrossProjects(params) {
      const found = await this.RETRIEVE_CALL_DETAILS(params).catch((error) => {
        console.error("Error fetching call details:", error);
        return null;
      });
      if (found?.length) return found;

      // Startup only checks the project being opened, so the others may not
      // have been checked yet.
      await this.VALIDATE_REMAINING_ENTRIES().catch(() => {});

      const startKey = this.activeProjectKey;
      for (const entry of this.accessibleEntries) {
        if (entry.key === startKey) continue;
        try {
          await this.SWITCH_PROJECT(entry.key);
          const response = await this.RETRIEVE_CALL_DETAILS(params);
          if (response?.length) {
            this.getGptProfile();
            return response;
          }
        } catch (_) {
          continue;
        }
      }

      if (this.activeProjectKey !== startKey) {
        await this.SWITCH_PROJECT(startKey).catch(() => {});
      }
      return found;
    },

    getCallInformation() {
      const sessionId = this.$route.query.session_id;
      const callId = this.$route.query.call_id;
      if (!sessionId && !callId) {
        console.error("Session ID or Call ID is missing in the route query.");
        this.fullLoading = false;
        this.speechLoading = false;
        return;
      }
      return this.retrieveCallAcrossProjects({
        session_id: sessionId,
        call_id: callId,
      })
        .then((response) => {
          if (response) {
            this.callDetails =
              response && response.length > 0 ? response[0] : null;
            if (this.callDetails?.call_status === "finished") {
              clearInterval(this.callDurationInterval);
              this.startChorusPolling();
            }
            if (this.callDetails && this.callDetails?.client_info) {
              this.client_info = this.callDetails.client_info;
            } else if (this.callDetails?.sip_data) {
              const matchedClients = findClientsFromSipData(this.callDetails.sip_data);
              this.client_info = matchedClients.length > 0 ? matchedClients[0] : null;
              if (this.client_info) {
                this.callDetails.client_info = this.client_info;
                this.updateCallDetail('client_info', this.client_info);
              }
            }
            if (this.callDetails) {
              const counselorBackfillPatch = getCounselorNameBackfillPatch(this.callDetails);

              if (counselorBackfillPatch) {
                Object.assign(this.callDetails, counselorBackfillPatch);

                if (counselorBackfillPatch.dest_id) {
                  const { dest_id, ...extra } = counselorBackfillPatch;
                  this.updateCallDetail("dest_id", dest_id, false, extra);
                } else if (counselorBackfillPatch.counselor_name) {
                  this.updateCallDetail("counselor_name", counselorBackfillPatch.counselor_name);
                }
              }
            }
          }
          this.fullLoading = false;
          this.speechLoading = false;
          return response;
        })
        .catch((error) => {
          console.error("Error fetching call details:", error);
          this.fullLoading = false;
          this.speechLoading = false;
        });
    },
    startChorusPolling() {
      if (this.callDetails?.chorus_task_id && (!this.callDetails.audio_text || !this.callDetails.audio_text_diarized)) {
        this.stopChorusPolling();
        if (!this.callDetails.audio_text && !this.callDetails.audio_text_diarized) {
          this.checkChorusTaskStatus();
        }
        this.chorusPollingInterval = setInterval(() => {
          this.checkChorusTaskStatus();
        }, 30000);
      }
    },
    stopChorusPolling() {
      if (this.chorusPollingInterval) {
        clearInterval(this.chorusPollingInterval);
        this.chorusPollingInterval = null;
      }
    },
     async checkChorusTaskStatus() {
      try {
        if (this.activeChorusTaskType === 'rerun') {
          this.reRunLoading = true;
        } else if (this.activeChorusTaskType === 'transcription' || this.activeChorusTaskType === 'diarization') {
          this.improveLoading = true;
        } else {
          this.reRunLoading = true;
        }

        const response = await this.GET_CHORUS_TASK_STATUS(
          { chorus_task_id: this.callDetails.chorus_task_id}
        );
        if (response?.status === 'failed') {
          if (this.chorusFailureCount >= 3) {
            this.reRunLoading = false;
            this.improveLoading = false;
            this.stopChorusPolling();
            return;
          }
          let payload = {};
          if(this.activeChorusTaskType === 'all' || this.activeChorusTaskType === 'diarization') {
            payload.improve = this.activeChorusTaskType;
          }
          this.chorusFailureCount++;
          await this.generatePresignedUrlAndRunChorus(payload);
        } else if (response?.status === 'completed') {
          this.chorusFailureCount = 0;
        }
        const updateData = {};
        let hasUpdates = false;
        
        if (response.results?.transcription?.text && !this.callDetails.audio_text) {
          updateData.audio_text = response.results.transcription.text;
          updateData.audio_text_processing_time = (response.timings?.transcription || 0 ) + (response.timings?.queue_wait || 0);
          updateData.text_processing_queue_time = response.timings?.queue_wait || 0;
          hasUpdates = true;
        }
        if (response.results?.diarization?.text && !this.callDetails.audio_text_diarized) {
          updateData.audio_text_diarized = response.results.diarization.text;
          updateData.audio_text_diarized_processing_time = (response.timings?.diarization || 0 ) + (response.timings?.queue_wait || 0);
          hasUpdates = true;
        }
        if (hasUpdates) {
          await this.updateCallDetailWithDictionary(updateData);
          await this.getCallInformation();
        }
        if (this.callDetails.audio_text && this.callDetails.audio_text_diarized && response?.status === 'completed') {
          this.reRunLoading = false;
          this.improveLoading = false;
          this.activeChorusTaskType = null;
          this.stopChorusPolling();
        }
      } catch (error) {
        this.reRunLoading = false;
        this.improveLoading = false;
        if(this.chorusFailureCount >= 3) {
          this.stopChorusPolling();
        }
        console.error("Error checking chorus task status:", error);
      }
    },
    updateCallDetailWithDictionary(updateData) {
      const dataWithDictionary = {
        ...updateData,
        'use_dictionary': true
      };
      return this.UPDATE_CALL_DETAIL({
        session_id: this.callDetails?.session_id,
        data: dataWithDictionary
      })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error("Error updating call detail", error);
        });
    },
    updateCallDetail(field, value, summary_update = false, extraParams = {}) {
      const data = { [field]: value, ...extraParams };
      return this.UPDATE_CALL_DETAIL({
        session_id: this.callDetails?.session_id,
        data: data
      })

        .then((response) => {
          if (response) {
            if (summary_update) {
              summary_update === "generated"
                ? this.showSnackbar("概要が正常に生成されました。", "success")
                : this.showSnackbar("概要が正常に変更されました。", "success");
            } else if (field !== "client_info" && field !== "counselor_name") {
              this.showSnackbar("情報は正常に更新されました。", "success");
            }
            this.callDetails[field] = value;
            if (extraParams && Object.keys(extraParams).length > 0) {
              Object.assign(this.callDetails, extraParams);
            }
            this.resetEditState(field);
          }
          this.resetFields();
          this.generateSummaryLoader = false;
          return response;
        })
        .catch((error) => {
          console.error("Error updating call detail:", error);
          this.resetFields();
          this.generateSummaryLoader = false;
        })
        .catch((error) => {
          // Show error snackbar
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "更新中にエラーが発生しました。";
          this.showSnackbar(message, "error");

          // Always stop loader and reset fields even on failure
          this.resetFields();
          this.generateSummaryLoader = false;
        });
    },
    resetFields() {
      this.editedSourceInfo = "";
      this.editedDestInfo = "";
      this.editedConversationTitle = "";
      this.editedSourcePin = "";
      this.modifiedSummaryQuery = "";
      this.genaratedGptProfile = null;
      this.selectedSummaryIndex = 0;
    },
    resetEditState(field) {
      const editStateMap = {
        src_info: "isEditSourceInfo",
        src_pin: "isEditSourcePin",
        dest_info: "isEditDestInfo",
        conversation_title: "isEditTitle",
      };
      if (editStateMap[field]) {
        this[editStateMap[field]] = false;
      }
    },
    getCallLiveDuration(startTime) {
      const start = new Date(startTime);
      const now = new Date();
      const diff = now - start;
      const hours = Math.floor(diff / 1000 / 60 / 60);
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      return `${hours}h ${minutes}m ${seconds}s`;
    },
    updateLiveDuration(startTime) {
      const start = new Date(startTime);
      const now = new Date();
      const diff = now - start;
      const seconds = Math.floor((diff / 1000) % 60);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const hours = Math.floor(diff / (1000 * 60 * 60));
      this.callDetailsLiveDuration = `${hours}h:${minutes}m:${seconds}s`;
    },
    getCallDetailsDuration() {
      if (this.callDetails?.call_status === "finished") {
        clearInterval(this.callDurationInterval);
        const startTime = new Date(this.callDetails?.start_time);
        const endTime = new Date(this.callDetails?.end_time);
        const diff = endTime - startTime;
        const seconds = Math.floor((diff / 1000) % 60);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const hours = Math.floor(diff / (1000 * 60 * 60));
        return `${hours}h:${minutes}m:${seconds}s`;
      }
      return "録音中";
    },
    getTimeDuration(start, end) {
      if (!start || !end) {
        return "N/A";
      }
      const startTime = new Date(start);
      const endTime = end ? new Date(end) : new Date();
      const diff = endTime - startTime;
      const seconds = Math.floor((diff / 1000) % 60);
      const minutes = Math.floor((diff / (1000 * 60)));
      return `${minutes}m:${seconds}s`;
    },
    getGptProfileName(profileId) {
      const profile = this.gptProfiles.find(
        (profile) => profile.id === profileId
      );
      return profile ? profile.name : "N/A";
    },
    toUrlSafeBase64(base64String = "") {
      return base64String
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
    },
    encryptData(data = {}, secretKey = "") {
      const jsonData = JSON.stringify(data);
      const encryptedData = CryptoJS.AES.encrypt(
        jsonData,
        secretKey
      ).toString();
      return this.toUrlSafeBase64(encryptedData);
    },
    redirectDetailsPage(conversation_id) {
      const user = getCurrentUser();
      const data = {
        auth_token: user?.access_token,
        project_id: this.activeProjectId,
      };
      const parts = conversation_id?.split("-");
      const secretKey = `${parts[0]}#${parts[parts.length - 1]}`;
      const urlSafeEncryptedData = this.encryptData(data, secretKey);
      this.token = urlSafeEncryptedData;
      const url = `${this.platformUrl}conversations/${conversation_id}?token=${urlSafeEncryptedData}`;
      window.open(url, "_blank");
    },
    refreshSpeech() {
      this.speechLoading = true;
      if (this.socket) {
        this.socket.onclose = () => {
          // Wait for close before reconnecting
          console.log("WebSocket closed, reconnecting...");
          this.speechLoading = true;
          this.displayMessages = [];
          this.messages = [];
          this.isFirstLoad = true;
          this.getCallInformation();
          this.connectWebSocket();
        };
        this.socket.close();
      } else {
        this.getCallInformation();
        this.connectWebSocket(); // If no socket exists, just connect
      }
    },
    copyToClipboard(text) {
      if (!text) return;

      // Transform like you do for VueMarkdown
      const formattedMarkdown = text
        .replace(/(^|\s)(\b(?!http|https)\w+):/g, "$1**$2**:")
        .replace(/。/g, "。\n");

      // Convert markdown → HTML (very basic, only bold + line breaks for now)
      const formattedHtml = formattedMarkdown
        .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
        .replace(/\n/g, "<br>");

      if (navigator.clipboard && navigator.clipboard.write) {
        const blobHtml = new Blob([formattedHtml], { type: "text/html" });
        const blobText = new Blob([formattedMarkdown], { type: "text/plain" });
        const data = [
          new ClipboardItem({
            "text/html": blobHtml,
            "text/plain": blobText,
          }),
        ];

        navigator.clipboard.write(data).then(
          () => {
            this.showSnackbar(
              "テキストがクリップボードにコピーされました。",
              "success"
            );
          },
          (err) => {
            console.error("Error copying text: ", err);
            this.showSnackbar("コピーに失敗しました。", "error");
          }
        );
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        // fallback → plain text
        navigator.clipboard.writeText(formattedMarkdown);
      } else {
        console.error("Clipboard API not supported");
        this.showSnackbar(
          "Clipboard functionality is not supported in this browser.",
          "error"
        );
      }
    },
    downloadFile(item) {
      let key = item?.audio_file_path;
      if (!key) {
        return;
      }
      if (key.includes("contents/f73e2850-d046-48ef-9aea-ad3d4d46b2db/")) {
        key = key.replace(
          "contents/f73e2850-d046-48ef-9aea-ad3d4d46b2db/",
          `contents/${this.activeAccountId}/`
        );
      }
      this.genaratePresignedUrl(key);
    },
    downloadTextFile(filename, textContent) {
      // 🔹 Inline formatting
      const formattedMarkdown = textContent
        .replace(/(^|\s)(\b(?!http|https)\w+):/g, "$1**$2**:") // bold for key:value
        .replace(/。/g, "。\n"); // add line breaks after Japanese period

      // 🔹 Add BOM for Japanese text support in Windows Notepad
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, formattedMarkdown], {
        type: "text/plain;charset=utf-8",
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(url), 100);
    },
    genaratePresignedUrl(key) {
      this.presignedUrlLoader = true;
      this.RETRIEVE_PRESIGNED_URL({ s3_key: key })
        .then((response) => {
          if (response) {
            window.open(response);
          }
          interactionUpdate(INTERACTION_POINT.CALL_DETAIL_DOWNLOAD_AUDIO_FILE, `音声ファイルをダウンロードする`, this.callDetails?.session_id);
          this.presignedUrlLoader = false;
        })
        .catch((error) => {
          console.error("Error generating presigned url: ", error);
          this.presignedUrlLoader = false;
        });
    },
    storeMaskedVersion(data, type) {
      const param = {};
      if (type == "full-audio-text") {
        param.masked_audio_text = data?.response;
        param.masking_time = data?.run_time || null;
      }
      if (type == "selectedSummaryIndex" || type == "conversationHistory") {
        let prevSummaryData = this.callDetails.summary_text;
        prevSummaryData[this.selectedSummaryIndex].masked_text = data?.response;
        prevSummaryData[
          this.selectedSummaryIndex
        ].masking_time = data?.run_time || null;
        param.summary_text = prevSummaryData;
      }
      this.SAVE_MASKED_TRANSCRIPTION({
        session_id: this.callDetails?.session_id,
        param,
      })
        .then(() => {})
        .catch((error) => {
          console.error("Error store maske ", error);
        });
    },
    handleGenerateMaskedVersion(text, type, index) {
      if (
        this.genarateMaskedLoader ||
        this.genarateSummaryMaskedLoader ||
        this.conversationIndexloading[index - 1]
      ) {
        this.showSnackbar("処理中です。しばらくお待ちください。", "warning");
        return; // Prevent multiple clicks
      }
      if (type == "full-audio-text") {
        this.genarateMaskedLoader = true;
        interactionUpdate(INTERACTION_POINT.MASKING_TEXT_AUDIO, `アイコンを再生成`, this.callDetails?.session_id);
      } else if (type == "selectedSummaryIndex") {
        this.genarateSummaryMaskedLoader = true;
        interactionUpdate(INTERACTION_POINT.MASKING_TEXT_SUMMARY, `アイコンを再生成`, this.callDetails?.session_id);
      } else {
        this.$set(this.conversationIndexloading, index - 1, true);
        interactionUpdate(INTERACTION_POINT.MASKING_TEXT_SUMMARY, `要約_${index}`, this.callDetails?.session_id);
      }
      const data = {
        user_id: this.userProfile?.id || this.defaultUser,
        member_id: this.userProfile?.id || this.defaultMember,
        query: text,
        conversation_type: "chat",
        gpt_profile_id: this.activeMaskProfileId,
        top_k: 20,
        is_keyword_enabled: false,
      };
      this.GENERATE_MASKED_TRANSCRIPTION({ data })
        .then((response) => {
          if (response) {
            if (type == "full-audio-text") {
              let prevCallDetails = this.callDetails;
              let updatedCallDetails = {
                ...prevCallDetails,
                masked_audio_text: response.response,
                masking_time: response.run_time || null,
              };
              this.callDetails = updatedCallDetails;
              this.genarateMaskedLoader = false;
              this.storeMaskedVersion(response, type);
            } else if (type == "selectedSummaryIndex") {
              let prevCallDetails = this.callDetails;
              prevCallDetails.summary_text[
                this.selectedSummaryIndex
              ].masked_text = response.response;
              this.callDetails = prevCallDetails;
              this.genarateSummaryMaskedLoader = false;
              this.storeMaskedVersion(response, type);
              this.storeMaskedConversation(
                response.response,
                this.callDetails.summary_text?.[this.selectedSummaryIndex]
                  ?.conversation_id
              );
            } else {
              let prevConversationList = this.conversationHistory;
              prevConversationList[
                this.conversationHistory.length - index
              ].masked_response = response.response;
              this.conversationHistory = prevConversationList;
              this.$set(this.conversationIndexloading, index - 1, false);
              const conversation_id =
                this.conversationHistory[
                  this.conversationHistory?.length - index
                ].conversation_id;
              if (
                conversation_id ==
                this.callDetails.summary_text?.[this.selectedSummaryIndex]
                  ?.conversation_id
              ) {
                let prevCallDetails = this.callDetails;
                prevCallDetails.summary_text[
                  this.selectedSummaryIndex
                ].masked_text = response.response;
                this.callDetails = prevCallDetails;
                this.storeMaskedVersion(response, type);
              }
              this.storeMaskedConversation(response.response, conversation_id);
            }
          }
        })
        .catch((error) => {
          console.error("Error generate maske version: ", error);
          this.genarateMaskedLoader = false;
          this.genarateSummaryMaskedLoader = false;
          this.$set(this.conversationIndexloading, index - 1, false);
        });
    },
    storeMaskedConversation(response, conversation_id) {
      this.UPDATE_MASKED_CONVERSATION({
        conversation_id: conversation_id,
        masked_response: response,
      })
        .then(() => {})
        .catch((error) => {
          console.error("Error store maske conversation: ", error);
        });
    },
    generateNewSummary(profileId) {
      this.genaratedGptProfile = profileId;
      this.generateNewSummaryModal = true;
    },
    generateSummary() {
      this.generateSummaryLoader = true;
      this.generateNewSummaryModal = false;
      const ask_session_id = `${this.genaratedGptProfile}_${this.callDetails?.session_id}`;
      const data = {
        session_id: ask_session_id,
        user_id: this.userProfile?.id || this.defaultUser,
        member_id: this.userProfile?.id || this.defaultMember,
        query: `Please analyze and summarize this conversation: ${this.callDetails?.audio_text ? this.callDetails.audio_text : this.messages.join('\n ')}`,
        conversation_type: "chat",
        gpt_profile_id: this.genaratedGptProfile,
        result_includes: [],
        top_k: 20,
        is_keyword_enabled: false,
      };
      this.RETRIEVE_GPT_CONVERSATION_SUMMARY({ data })
        .then((response) => {
          if (response) {
            const new_summary_metadata = {
              gpt_profile: response?.gpt_profile_id,
              text: response?.response,
              conversation_id: response?.conversation_id,
              session_id: ask_session_id,
              process_time: response?.run_time || null,
            };
            let summary_metadata = this.callDetails?.summary_text || [];
            summary_metadata = summary_metadata.filter(
              (item) => item.gpt_profile !== this.genaratedGptProfile
            );
            summary_metadata.unshift(new_summary_metadata);
            this.updateCallDetail(
              "summary_text",
              summary_metadata,
              "generated"
            );
          }
        })
        .catch((error) => {
          console.error("Error generating summary: ", error);
          this.generateSummaryLoader = false;
          this.showSnackbar("概要の生成に失敗しました。", "error");
        }).finally(() => {
          interactionUpdate(INTERACTION_POINT.CREATE_SUMMARY, this.genaratedGptProfile, this.callDetails?.session_id);
        });
    },
    modifySummary(summary, index) {
      if (!this.modifiedSummaryQuery) {
        this.showSnackbar(
          "概要を変更するには、有効なクエリを入力してください。",
          "error"
        );
        return;
      }
      this.generateSummaryLoader = true;
      const ask_session_id = `${summary.gpt_profile}_${this.callDetails?.session_id}`;
      const data = {
        session_id: summary.session_id || ask_session_id,
        user_id: this.userProfile?.id || this.defaultUser,
        member_id: this.userProfile?.id || this.defaultMember,
        query: this.modifiedSummaryQuery,
        conversation_type: "chat",
        gpt_profile_id: summary.gpt_profile,
        result_includes: [],
        top_k: 20,
        is_keyword_enabled: false,
      };
      this.RETRIEVE_GPT_CONVERSATION_SUMMARY({ data })
        .then((response) => {
          if (response) {
            const new_summary_metadata = {
              gpt_profile: response?.gpt_profile_id,
              text: response?.response,
              conversation_id: response?.conversation_id,
              session_id: ask_session_id,
            };
            let summary_metadata = this.callDetails?.summary_text || [];
            summary_metadata.splice(index, 1);
            summary_metadata.unshift(new_summary_metadata);
            this.updateCallDetail("summary_text", summary_metadata, "modified");
          }
        })
        .catch((error) => {
          console.error("Error modifying summary: ", error);
          this.generateSummaryLoader = false;
          this.showSnackbar("概要の変更に失敗しました。", "error");
        }).finally(() => {
          interactionUpdate(INTERACTION_POINT.MODIFY_SUMMARY, `${summary?.gpt_profile}`, this.callDetails?.session_id);
        });
    },
    handleModifySummary(e, summary, index) {
      if (!e.shiftKey && e.keyCode === 13 && !this.isComposing) {
        e.preventDefault();
        this.modifySummary(summary, index);
      }
    },
    openConversationHistory(summary) {
      const session_id =
        summary.session_id ||
        `${summary.gpt_profile}_${this.callDetails?.session_id}`;
      this.conversationHistoryModal = true;
      this.conversationHistoryLoader = true;
      this.RETRIEVE_CONVERSATION_HISTORY({ session_id })
        .then((response) => {
          if (response) {
            this.conversationHistory = response.conversations;
            this.totalCoverstationHistory = response.matched_conversation;
          }
          this.conversationHistoryLoader = false;
          this.conversationIndexloading = response.conversations.map(
            () => false
          );
        })
        .catch((error) => {
          console.error("Error retrieving conversation history: ", error);
          this.conversationHistoryLoader = false;
        });
    },
    closeSummaryHistoryModal() {
      this.conversationHistoryModal = false;
      this.summaryTabIndexes = {};
    },
    redirectHomePage() {
      this.$router.push({ path: "/" });
    },
    closeSIPDataModal() {
      this.SIPDataModal = false;
    },
    scrollToBottomSpeech() {
      this.$nextTick(() => {
        if (this.$refs.speechContainer) {
          this.$refs.speechContainer.scrollTop =
            this.$refs.speechContainer.scrollHeight;
        }
      });
    },
    editCallDetails(field) {
      let data = {
        modal_title: "",
        session_id: this.callDetails?.session_id,
        data: [{}],
      };

      switch (field) {
        case "analog_customer_info":
          data.modal_title = "発信者情報を編集";
          data.data = [
            {
              label: "発信者番号",
              value: this.callDetails?.src_id,
              isEditable: true,
              field: "src_id",
              input: "text",
            },
          ];
          break;
        case "analog_destination_info":
          data.modal_title = "着信先情報を編集";
          data.data = [
            {
              label: "着信先",
              value: this.callDetails?.dest_id,
              isEditable: true,
              field: "dest_id",
              input: "text",
            },
            {
              label: "部門",
              value: this.callDetails?.dest_department,
              isEditable: true,
              field: "dest_department",
              input: "text",
            },
          ];
          break;
        case "customer_info":
          data.modal_title = "顧客情報を編集";
          data.data = [
            {
              label: "顧客ID",
              value: `${this.callDetails?.src_ip_address}:${this.callDetails?.src_port}`,
              isEditable: false,
              field: "N/A",
              input: "text",
            },
            {
              label: "Pin",
              value: this.callDetails?.src_pin,
              isEditable: true,
              field: "src_pin",
              input: "text",
            },
            {
              label: "メモ",
              value: this.callDetails?.src_info,
              isEditable: true,
              field: "src_info",
              input: "textarea",
            },
          ];
          break;
        case "operator_info":
          data.modal_title = "オペレーター情報を編集";
          data.data = [
            {
              label: "オペレーターID",
              value: `${this.callDetails?.dest_ip_address}:${this.callDetails?.dest_port}`,
              isEditable: false,
              field: "N/A",
              input: "text",
            },
            {
              label: "部門",
              value: this.callDetails?.dest_department,
              isEditable: false,
              field: "dest_department",
              input: "text",
            },
            {
              label: "メモ",
              value: this.callDetails?.dest_info,
              isEditable: true,
              field: "dest_info",
              input: "textarea",
            },
          ];
          break;
        case "title":
          data.modal_title = "タイトルを編集";
          data.data = [
            {
              label: "タイトル",
              value: this.callDetails?.conversation_title,
              isEditable: true,
              field: "conversation_title",
              input: "text",
            },
          ];
          break;
        default:
          break;
      }
      this.callEditedInfo = data;
      this.callEditedModal = true;
    },
    closeCallEditedModal() {
      this.callEditedModal = false;
    },
    showFullTextFunc(text) {
      this.fullText = text;
      this.showFullText = true;
    },
    getDuration(start, end) {
      const startDate = new Date(start || new Date());
      const endDate = new Date(end || new Date());
      const duration = endDate - startDate;
      const seconds = Math.floor((duration / 1000) % 60);
      const minutes = Math.floor((duration / (1000 * 60)) % 60);
      const hours = Math.floor(duration / (1000 * 60 * 60));
      return `${hours}h:${minutes}m:${seconds}s`;
    },
    handlePhoneNumberFormat(number) {
      // check the number have the letter A-Z or a-z
      let hasLetter = /[a-zA-Z]/.test(number);
      if (hasLetter) {
        return number || "N/A";
      }
      if (number?.length > 0) {
        let digitsOnly = number?.replace(/\D/g, "");
        if(digitsOnly.length === 4) {
          return getDestFullPhoneName(number);
        }
        if (digitsOnly > 4) {
          number = number?.toString()?.replace(/[-\s]/g, ""); // remove all space and '-'
          const groups = [];
          while (number.length > 4) {
            groups.unshift(number.slice(-4)); // take last 4 digits
            number = number.slice(0, -4); // remove last 4 digits
          }
          if (number.length) groups.unshift(number); // remaining digits at start
          return groups.join("-") || "N/A";
        } else {
          return number || "N/A";
        }
      } else {
        return "N/A";
      }
    },
    async deleteCallSession(type) {
      this.deleteModal = type;
    },
    async deleteConfirm() {
      if (this.callDetails?.session_id) {
        this.DELETE_CALL_DETAIL({ session_id: this.callDetails?.session_id })
          .then((res) => {
            if (res) {
              this.deleteCallSession(false);
              interactionUpdate(INTERACTION_POINT.DELETE_CALL, `削除アイコン`, this.callDetails?.session_id);
              this.$toast.show(
                "通話が正常に削除されました。",
                "success",
                2000,
                "delete-call-session-success"
              );
            }
            setTimeout(() => {
              this.$router.push({ path: "/" });
            }, 1000);
          })
          .catch((error) => {
            console.error("Error deleting call:", error);
          });
      } else {
        this.$toast.show(
          "「エラーが発生しました。」",
          "error",
          2000,
          "delete-call-session-error"
        );
      }
    },
    closeWindow() {
      if (typeof window.close !== 'undefined') window.close();
    },
    async forceReRunChorusTask(options = {}) {
      this.chorusStatusModal = false;
      const { improve = null } = options;
      if (this.reRunLoading || this.improveLoading) return;
      
      if (improve) {
        if (improve === 'all') {
          this.reRunLoading = true;
        } else {
          this.improveLoading = true;
        }
        this.activeChorusTaskType = improve;
      } else {
        this.reRunLoading = true;
        this.activeChorusTaskType = 'rerun';
      }
      
      try {
        if (this.callDetails?.chorus_task_id && !improve) {
          const taskResponse = await this.GET_CHORUS_TASK_STATUS({
            chorus_task_id: this.callDetails.chorus_task_id
          });
          this.chorusTaskStatus = taskResponse.status;
          if (this.chorusTaskStatus === 'failed') {
            await this.generatePresignedUrlAndRunChorus({ improve: 'all' });
          } else {
            this.chorusStatusMessage = this.getStatusMessage(this.chorusTaskStatus);
            this.chorusStatusModal = true;
            this.reRunLoading = false;
            this.activeChorusTaskType = null;
            return;
          }
        } else {
          await this.generatePresignedUrlAndRunChorus({ improve });
        }
      } catch (error) {
        console.error('Error in force re-run:', error);
      } finally {
        if (!this.chorusPollingInterval) {
          this.reRunLoading = false;
          this.improveLoading = false;
        }
      }
    },
    async confirmImproveTranscript() {
      await this.forceReRunChorusTask({ improve: 'diarization' });
      this.improveTranscriptModal = false;
    },
    
    getStatusMessage(status) {
      const messages = {
        queued: '文字起こしがキューに登録されました。しばらくお待ちください。',
        processing: '転写を処理中です。', 
        completed: '現在の文字起こしおよび話者分離の情報は、上書き保存されます。'
      };
      return messages[status] || `タスク状態: ${status}`;
    },
    async generatePresignedUrlAndRunChorus(options = {}) {
      const { improve = null } = options;
      if (!this.callDetails?.audio_file_path && !this.callDetails?.chorus_task_id) {
        this.showSnackbar('何か問題が発生しました', 'error');
        return;
      }
      try {
        const audio_url = await this.RETRIEVE_PRESIGNED_URL({
          s3_key: this.callDetails.audio_file_path
        });
        if (this.callDetails?.chorus_task_id) {
          const task_id =  this.callDetails.chorus_task_id;
          const chorusResponse = await this.RE_RUN_CHORUS_TASK({ task_id, improve, audio_url });
          if (chorusResponse && chorusResponse.task_id) {
            await this.updateTaskIdAndStartPolling(chorusResponse.task_id);
          }
        } else {
          const chorusResponse = await this.CREATE_TRANSCRIPTION({ audio_url: audio_url, improve });
        
        if (chorusResponse && chorusResponse.task_id) {
          this.showSnackbar('再実行が正常に送信されました。', 'success');
          await this.updateTaskIdAndStartPolling(chorusResponse.task_id)
        }
      }
      } catch (error) {
        this.showSnackbar('オーディオファイルを生成できません。', 'error');
        console.error('Error generating presigned URL or get chorus task status:', error);
      }
    },
    async updateTaskIdAndStartPolling(task_id) {
      this.showSnackbar('強制的に転写生成が開始されました。', 'success');
      let payload = {};
      if(this.activeChorusTaskType === 'diarization') {
        payload = {
          audio_text_diarized: null
        }
      } else if(this.activeChorusTaskType === 'rerun' || this.activeChorusTaskType === 'all') {
        payload = {
          audio_text: null,
          audio_text_diarized: null
        }
      }
      await this.updateCallDetail(
        'chorus_task_id', task_id, false,
         payload
      );
      await this.getCallInformation();
      this.startChorusPolling();
    }
  },
};
</script>
<style scoped>
.offset-title {
  font-size: 18px !important;
  font-weight: 500;
  color: #3f4652;
}
.details-header {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
  border-bottom: 1px solid #e2e2e2;
  height: 40px;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
  padding: 20px 0px;
  width: auto;
}
.border {
  border: 1px solid #e2e2e2 !important;
}
.information-div {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin: 8px 0;
}
.information-div-analog {
  display: grid;
  gap: 20px;
  margin: 8px 0;
}
.information-card {
  padding: 12px 20px;
  border-radius: 12px;
  background: #ffffff4d;
  border: 1px solid #e2e2e2;
  backdrop-filter: blur(20px);
}
.information-column {
  align-items: center;
  justify-content: start;
  gap: 10px;
  margin-top: 10px;
  display: grid;
  grid-template-columns: 2fr 1fr 2fr;
}
.information-column.first-info-col {
  grid-template-columns: 2fr 2fr;
}
.card-title {
  font-size: 16px;
  font-weight: 500;
  color: #10141a;
}
.info-title {
  font-size: 12px;
  font-weight: 400;
  color: #595959;
}
.info-value {
  font-size: 14px;
  font-weight: 400;
  color: #10141a;
}
.info-time {
  padding-left: 6px;
  font-size: 13px;
  font-weight: 400;
  color: #3f4652;
}
.call-status-card {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 3fr 3fr;
  gap: 10px;
}
.call-status-card--analog {
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}
.summary-div {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  height: calc(100vh - 370px);
}
.generate-summary-btn {
  width: auto;
  padding-right: 25px !important;
  height: 28px;
  justify-content: space-between;
  padding: 0 12px;
  border-radius: 4px;
  background-color: #069ea8;
  box-shadow: 0px 4px 12px 0px #00000014;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23222222'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 6px center;
  background-size: 16px;
}
.summary-text-div {
  height: 100%;
}
.speech-text {
  background-color: white;
  overflow-y: auto;
  scrollbar-width: thin;
  height: calc(100% - 50px);
}
.summary-text {
  background-color: #ffffff4d;
  border-color: #e4e4e4;
  overflow-y: auto;
  scrollbar-width: thin;
  padding: 0 !important;
  height: calc(100% - 40px);
}
.summary-profile {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 8px 0 !important;
  border-right: 1px solid #e4e4e4;
  scrollbar-width: thin;
}
.summary-text-sinlge {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 8px !important;
  scrollbar-width: thin;
  color: #3f4652;
}
.summary-profile-tab {
  font-size: 12px;
  color: #3f4652;
  cursor: pointer;
  border-radius: 6px;
  padding: 6px;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 400;
  margin-left: 5px;
  margin-right: 5px;
}
.summary-profile-tab-active {
  background-color: #194fa2;
  color: #ffffff;
}
@media (max-width: 768px) {
  .call-status-card {
    grid-template-columns: 1fr;
  }
  .information-div {
    grid-template-columns: 1fr;
  }
  .information-column {
    grid-template-columns: 1fr;
  }
  .main-container {
    overflow-y: auto;
  }
  .summary-div {
    grid-template-columns: 1fr;
    height: calc(100vh - 80px);
  }
  .download-file span {
    display: none;
  }
  .generate-summary-btn {
    width: 100%;
  }
  .summary-profile {
    height: fit-content;
  }
}
</style>
